import { ids as stageIds } from '../../stage/Id';

export const ids = [...stageIds, 'chat', 'assignee', 'sales-person', 'customer-contact'] as const;
